import React, { useEffect, useState } from "react";
import Toolbar from "./components/Toolbar";
import PageNavigationBar from "./components/PageNavigationBar";
import PageThumbnailPanel from "./components/PageThumbnailPanel";
import AnnotationPanel from "./components/AnnotationPanel";
import PDFViewer from "./components/PDFViewer";
import { Flex, Splitter, theme } from "antd";


const PDF_URL = "./sample.pdf";
const PDF_ID = "sample-pdf-1";
const API_URL = "http://localhost:4000/api/annotations"; // adjust if your backend is elsewhere

function PDFAnnotation() {
    const [annotations, setAnnotations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [numPages, setNumPages] = useState(1);
    const [drawMode, setDrawMode] = useState("select");
    const { token: { colorBgContainer, borderRadiusLG, colorPrimary } } = theme.useToken();
    const [color, setColor] = useState(colorPrimary);
    const [navBarVisible, setNavBarVisible] = useState(true);
    const [thumbnailsVisible, setThumbnailsVisible] = useState(true);

    // --- Load all annotations when the PDF loads ---
    useEffect(() => {
        fetch(`${API_URL}?pdfId=${PDF_ID}`)
            .then(res => res.json())
            .then(data => setAnnotations(data))
            .catch(err => {
                console.error("Failed to load annotations", err);
                setAnnotations([]);
            });
    }, []);

    // --- Save new annotation to backend and update UI ---
    const addAnnotation = (ann) => {
        fetch(API_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(ann),
        })
            .then(res => res.json())
            .then(saved => setAnnotations(prev => [...prev, saved]))
            .catch(err => {
                alert("Failed to save annotation. Try again!");
            });
    };

    // --- Save bookmark as annotation ---
    const addBookmark = (page) => {
        if (annotations.some(a => a.type === "bookmark" && a.page === page)) return;
        addAnnotation({
            pdfId: PDF_ID,
            page,
            type: "bookmark",
            boundingBox: null,
            commentText: "",
        });
    };

    return (
        <div style={{ height: 'calc(100svh - 36px)', width: '100%', display: "flex", flexDirection: "column", minWidth: 0, minHeight: 0, gap: 16 }}>

            <Flex style={{ width: '100%' }}>
                <Splitter
                    style={{
                        height: 'calc(100svh - 16px)',
                        borderRadius: borderRadiusLG,
                    }}
                >
                    {thumbnailsVisible && (
                        <Splitter.Panel
                            // collapsible
                            defaultSize={100}
                            min={100}
                            max={200}
                        >
                            <div style={{
                                overflowY: 'auto',
                                height: '100%',
                                scrollbarWidth: 'none', /* Firefox */
                                msOverflowStyle: 'none', /* IE and Edge */
                                // backgroundColor: colorBgContainer,
                                padding: 16,
                                borderRadius: borderRadiusLG
                            }}>
                                <PageThumbnailPanel
                                    pdfUrl={PDF_URL}
                                    numPages={numPages}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    annotations={annotations}
                                />
                            </div>
                        </Splitter.Panel>
                    )}
                    <Splitter.Panel style={{ display: 'flex', flexDirection: 'column' }}>
                        <Flex align="center" justify="space-between" style={{marginBottom:16}}>
                            <Toolbar
                                navBarVisible={navBarVisible}
                                setNavBarVisible={setNavBarVisible}
                                thumbnailsVisible={thumbnailsVisible}
                                setThumbnailsVisible={setThumbnailsVisible}
                                drawMode={drawMode}
                                setDrawMode={setDrawMode}
                                color={color}
                                setColor={setColor}
                            />
                            {navBarVisible && (
                                <PageNavigationBar
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    numPages={numPages}
                                    annotations={annotations}
                                    onAddBookmark={addBookmark}
                                />
                            )}
                        </Flex>
                        <div
                            style={{
                                flex: 1,
                                position: 'relative',
                                overflow: 'auto',
                            }}
                        >
                            <PDFViewer
                                pdfUrl={PDF_URL}
                                pdfId={PDF_ID}
                                annotations={annotations}
                                onAddAnnotation={addAnnotation}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                setNumPages={setNumPages}
                                drawMode={drawMode}
                                color={color}
                            />
                        </div>
                    </Splitter.Panel>
                    <Splitter.Panel
                        collapsible={{ end: true }}
                        defaultSize={280}
                        min={380}
                        // max={400}
                        style={{
                            zIndex: 2,
                            margin: "0 8px",
                            overflowY: 'auto',
                            height: '100%',
                            minWidth: 380,
                            scrollbarWidth: 'none', /* Firefox */
                            msOverflowStyle: 'none', /* IE and Edge */

                        }}
                    >
                        <AnnotationPanel
                            annotations={annotations}
                            onJumpToAnnotation={(ann) => setCurrentPage(ann.page)}
                        />
                    </Splitter.Panel>
                </Splitter>
            </Flex>
        </div>
    );
}

export default PDFAnnotation;
